import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { partners } from "../../../models/mockdata";
import { useTranslation } from "react-i18next";

const PartnerDetails = () => {
  const { t } = useTranslation();
  const [partner, setPartner] = useState("");
  let params = useParams();

  return (
    <div className="w-full h-full flex justify-center items-center px-[25px]">
      {partners
        .filter((partner) => partner.id == params.id)
        .map((partner) => (
          <div
            key={partner.id}
            className="flex flex-col justify-center items-center w-full max-w-[1140px] qhd:max-w-[60%]"
          >
            <div className="flex flex-col items-center py-[75px] sm:py-[100px]">
              <div className="text-sm sm:text-base text-primary_light font-medium">
                <div className="flex  gap-2">
                  {partner.type.map((item, index) => {
                    return (
                      <div className="text-[0.875rem]  text-primary ">
                        <p className="">{t(item)}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="text-[2.5rem] sm:text-[4.25rem]  text-primary text-center">
                {partner.name}
              </div>
              <div className="text-[1rem] sm:text-[1.25rem] text-primary_light text-center ">
                {partner.subtitle}
              </div>
            </div>

            <div className="w-full pb-[75px]">
              <img
                src={partner.banner}
                alt={partner.name}
                className="w-full object-cover"
              />
            </div>

            <div
              className="text-primary_light whitespace-pre-line  mx-auto  w-[80%]     text-justify pb-[75px]"
              style={{ lineHeight: 1.6 }}
            >
              {t(partner.content)}
            </div>
          </div>
        ))}
    </div>
  );
};

export default PartnerDetails;
